import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChangeLogMonitorService {

  constructor(private http: HttpClient) { }

  getMonitoringData(
    baseUrl: string,
    params: any
  ): Observable<any> {
    // Build URL with query parameters
    const url = `${baseUrl}/getSnsMessage`;

    // Create HTTP params
    let httpParams = new HttpParams()
      .set('client_key', params.client_key?.toString() || '')
      .set('le_key', params.le_key?.toString() || '')
      .set('le_type', params.le_type?.toString() || '')
      .set('submissionId', params.submissionId?.toString() || '');

    return this.http.get<any>(url, { 
      params: httpParams,
      withCredentials: true 
    });
  }

  saveRegenerateProcess(
    baseUrl: string,
    params: any
  ): Observable<any> {
    // Build URL with query parameters for POST request
    const url = `${baseUrl}/regenerateEntityChangeLog?tax_year=${params.tax_year}&le_key=${params.le_key}&data_level=${params.data_level}&filing_group_key=${params.filing_group_key}`;

    return this.http.post<any>(url, null, {
      withCredentials: true
    });
  }

  saveRerunPdfGeneration(
    baseUrl: string,
    params: any
  ): Observable<any> {
    // Use application/x-www-form-urlencoded for AngularJS compatibility
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${baseUrl}/saveJsonObject?action_code=xozyvn`;

    return this.http.post<any>(url, urlEncoded.toString(), {
      headers,
      withCredentials: true
    });
  }

  saveRerunXmlGeneration(
    baseUrl: string,
    params: any
  ): Observable<any> {
    // Use application/x-www-form-urlencoded for AngularJS compatibility
    // Same as saveRerunPdfGeneration - only difference is xml_pdf_flag in params
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${baseUrl}/saveJsonObject?action_code=xozyvn`;

    return this.http.post<any>(url, urlEncoded.toString(), {
      headers,
      withCredentials: true
    });
  }

  saveRetriggerMessage(
    baseUrl: string,
    params: any
  ): Observable<any> {
    // Build URL with query parameters for POST request
    const url = `${baseUrl}/reTriggerSNSMessagePublish?client_key=${params.client_key}&le_key=${params.le_key}&le_type=${params.le_type}&submissionId=${params.submissionId}`;

    return this.http.post<any>(url, null, {
      withCredentials: true
    });
  }
}
